import React, { useRef, useEffect } from 'react'
import {  Nav, Navbar, Container } from 'react-bootstrap'

import { useStaticQuery, graphql } from 'gatsby'

import { gsap, Power3 } from 'gsap'


const Navigation = () => {

    let navTextRef = useRef(null)

    let tl = gsap.timeline({
        delay: 0.5,
        defaults: {
            duration: 1.5,
            ease: Power3.eastOut
        },
        smoothChildTiming: true,
    })

        useEffect(() => {
        
        tl.from(
            navTextRef,
            {
                duration:  1.5,
                x: -150,
                ease: Power3.easeOut
                }
        )
        .from(
           '.navSlider',
           {
                duration: 1,
                y: -400,
                ease: Power3.easeOut,
                stagger: 0.2,
                },
        )
        
        }, [])

    const data = useStaticQuery(graphql`
        query {
            allContentfulHeader {
                edges {
                    node {
                        businessName
                        tagline
                        homeLink
                        link1
                        link2
                        link3
                        link4
                        }
                }
            }
        }
        `)

    const { 
        businessName, 
        tagline, 
        homeLink, 
        link1, 
        link2, 
        link3, 
        link4 } = data.allContentfulHeader.edges[0].node
    
    return (
        <header>
            <Navbar expand="lg" className='navbar navbar-light fixed-top py-3'>
                <Container>
                    <div href="#home" ref={el => { navTextRef = el }} className="navbar-brand d-inline align-middle">

                        <h2 id="business-name" className="text-sm-left business-name text-uppercase">{businessName}</h2>
                        <h4 id="business-tagline" className="text-success text-sm-center">{tagline}</h4>
                        
                    </div>
                    <Navbar.Toggle aria-controls="basic-navbar-nav" />
                    <Navbar.Collapse id="basic-navbar-nav">
                        <Nav as="ul" className="ml-auto">
                            <li><Nav.Link className="text-uppercase navSlider" href="#home">{homeLink}</Nav.Link></li>
                            <li><Nav.Link className="text-uppercase navSlider" href="#testimonials">{link1}</Nav.Link></li>
                            <li><Nav.Link className="text-uppercase navSlider" href="#teams">{link2}</Nav.Link></li>
                            <li><Nav.Link className="text-uppercase navSlider" href="#leaders">{link3}</Nav.Link></li>
                            <li><Nav.Link className="text-uppercase navSlider" href="#contact">{link4}</Nav.Link></li>
                        </Nav>
                    </Navbar.Collapse>
                </Container>
            </Navbar>
        </header>
    )
}

export default Navigation
